module.exports = "<nav class=\"footer navbar navbar-default navbar-fixed-bottom\" role=\"navigation\">    \r\n    <div>\r\n        <strong>Copyright</strong> Sergey Rogachev &copy; 2017\r\n    </div>\r\n</nav>"


//////////////////
// WEBPACK FOOTER
// ./src/app/app-footer/app-footer.component.html
// module id = 828
// module chunks = 1